import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles({
  table: {
    "& tbody": {
      textTransform: "uppercase",
      "& th,td": {
        fontWeight: "bold",
      },
    },
  },
  emptyMessage: {
    textAlign: "center",
    padding: "20px",
  },
});

const VenuesTable = ({ venues }) => {
  const classes = useStyles();

  // If no venues, show empty message
  if (!venues || venues.length === 0) {
    return (
      <div className={classes.emptyMessage}>
        <Typography variant="h6" color="textSecondary">
          No venues found
        </Typography>
      </div>
    );
  }

  // Get all unique keys from all venue objects
  const getAllKeys = () => {
    const keys = new Set();
    venues.forEach(venue => {
      Object.keys(venue).forEach(key => keys.add(key));
    });
    return Array.from(keys);
  };

  const columns = getAllKeys();

  // Helper function to format cell value
  const formatCellValue = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }
    if (typeof value === "object") {
      return JSON.stringify(value);
    }
    return String(value);
  };

  // Helper function to format column header
  const formatColumnHeader = (key) => {
    return key
      .replace(/([A-Z])/g, " $1") // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
      .trim();
  };

  const isLast = (index) => index === venues.length - 1;

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="venues table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column} align="left">
                {formatColumnHeader(column)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {venues.map((venue, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((column) => (
                <TableCell
                  key={column}
                  component="th"
                  scope="row"
                  style={{
                    borderBottom: isLast(rowIndex) ? 0 : undefined,
                  }}
                >
                  {formatCellValue(venue[column])}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default VenuesTable; 